var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24418_21414)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99908 9.41474L11.5344 12.9501C11.722 13.1377 11.9764 13.2431 12.2418 13.2431C12.5071 13.2431 12.7615 13.1377 12.9491 12.9501C13.1367 12.7625 13.2421 12.508 13.2421 12.2427C13.2421 11.9774 13.1367 11.723 12.9491 11.5354L9.41242 8.00007L12.9484 4.46474C13.0413 4.37185 13.1149 4.26159 13.1651 4.14024C13.2154 4.01889 13.2412 3.88884 13.2412 3.7575C13.2411 3.62617 13.2152 3.49613 13.165 3.37481C13.1147 3.25348 13.041 3.14325 12.9481 3.05041C12.8552 2.95756 12.7449 2.88392 12.6236 2.83369C12.5022 2.78346 12.3722 2.75762 12.2408 2.75766C12.1095 2.75769 11.9795 2.78358 11.8582 2.83387C11.7368 2.88416 11.6266 2.95785 11.5338 3.05074L7.99908 6.58607L4.46375 3.05074C4.37155 2.95519 4.26124 2.87895 4.13926 2.82649C4.01728 2.77402 3.88608 2.74638 3.7533 2.74516C3.62052 2.74394 3.48883 2.76918 3.36591 2.81941C3.24299 2.86963 3.1313 2.94383 3.03737 3.03768C2.94343 3.13153 2.86913 3.24314 2.81879 3.36601C2.76845 3.48889 2.74308 3.62055 2.74417 3.75333C2.74527 3.88611 2.77279 4.01734 2.82514 4.13937C2.87749 4.2614 2.95362 4.37178 3.04909 4.46407L6.58575 8.00007L3.04975 11.5361C2.95429 11.6284 2.87816 11.7387 2.82581 11.8608C2.77346 11.9828 2.74593 12.114 2.74484 12.2468C2.74375 12.3796 2.76911 12.5113 2.81945 12.6341C2.86979 12.757 2.9441 12.8686 3.03803 12.9625C3.13197 13.0563 3.24366 13.1305 3.36658 13.1807C3.4895 13.231 3.62119 13.2562 3.75396 13.255C3.88674 13.2538 4.01795 13.2261 4.13993 13.1737C4.26191 13.1212 4.37222 13.045 4.46442 12.9494L7.99908 9.41474Z",
    fill: "#D93131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24418_21414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.dc62bbe7be78aec16a6364dce1c8ed19.svg";
export { ForwardRef as ReactComponent };